
<template>
  <!--投诉处理-->
  <div class="advanced-form">
    <a-form :form="form">
      <div class="card">
        <div class="card-head">
          <h3>投诉人信息</h3>
        </div>
        <div class="card-body">
          <a-form-item class="value-indent" label="">
            <div class="complaints-box">
              <p class="avatar">
                <img :src="complainant.avatar" alt="">
              </p>
              <span class="name">{{complainant.name}}</span>
            </div>
          </a-form-item>
        </div>
      </div>

      <div class="card">
        <div class="card-head">
          <h3>投诉信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col v-for="(item, index) of objectInfo" :key="index" :span="item.span">
              <a-form-item class="value-indent" :label="item.label">
                <span v-if="item.key !== 'object_desc'" class="ant-form-text">{{item.value}}</span>

                <template v-else>
                  <div v-if="['1', '2'].includes(routeQuery.type)" class="complaints-box">
                    <p class="avatar">
                      <img :src="item.value.avatar" alt="">
                    </p>
                    <span class="name">{{item.value.name}}</span>
                  </div>

                  <div v-else>
                    <div>{{item.value.content}}</div>
                    <p v-if="item.value.object_nickname && item.value.object_time" :style="{textAlign: 'right'}">
                      <span :style="{color: '#0099FF'}">{{item.value.object_nickname}}</span>于<span :style="{color: '#0099FF'}">{{item.value.object_time}}</span>发布
                    </p>
                  </div>
                </template>

              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </div>

      <div class="card">
        <div class="card-head">
          <h3>投诉描述和证明</h3>
        </div>
        <div class="card-body">
          <template v-if="complainDetail.content || complainDetail.images">
            <p>{{complainDetail.content}}</p>
            <div class="pic-container">
              <div class="pic-box" v-for="(item, index) of complainDetail.images" :key="index">
                <img @click="() => {imgUrl = item; imgVisible = true;}" :src="item" alt="">
              </div>
            </div>
          </template>

          <a-empty v-else :image="emptyImage" />
        </div>
      </div>
    </a-form>

    <template>
      <x-toolbar :toolBarList="toolBarList" :btnLoading="btnLoading"></x-toolbar>
    </template>

    <!--投诉不成立的弹窗-->
    <a-modal
      :title="modalTitle"
      :visible="visible"
      @ok="handleSubmit"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      destroyOnClose
      centered
      :maskClosable="false"
      :keyboard="false"
    >
      <a-form :form="modalForm">
        <a-form-item v-if="modalType === 1" v-bind="$store.state.modal_ItemLayout" label="不成立原因">
          <a-textarea v-decorator="['handle_remark', { rules: [{ required: true, message: '请输入不成立原因' }]}]" placeholder="请输入不成立原因"></a-textarea>
        </a-form-item>

        <template v-if="modalType === 2">
          <a-form-item v-bind="$store.state.modal_ItemLayout" label="禁言原因">
            <a-select
              v-decorator="['chat_category_id', { rules: [{ required: true, message: '请选择禁言原因' }]}]"
              allowClear
              showSearch
              :filterOption="filterOption"
              placeholder="请选择禁言原因">
              <a-select-option v-for="(el, order) of reasonList" :key="order" :value="el.value">{{el.label}}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item v-bind="$store.state.modal_ItemLayout" label="禁言截止时间">
            <a-input v-decorator="['end_time', endTime()]" placeholder="单位为分钟，最大43200分钟"></a-input>
          </a-form-item>
        </template>
      </a-form>
    </a-modal>

    <!--图片的弹窗-->
    <a-modal
      :bodyStyle="{padding: '10px'}"
      :visible="imgVisible"
      @cancel="imgVisible=false"
      v-bind="$store.state.modalDetailConfig"
    >
      <div :style="{textAlign: 'center', overflowX: 'auto'}">
      <img :style="{width: 'auto', maxHeight: '800px'}" :src="imgUrl" alt="">
      </div>
    </a-modal>
  </div>
</template>

<script>
import { expireTime } from '../../../utils/mixins';
import { inputSearch } from 'ant-design-vue-admin-x';
import { Empty } from 'ant-design-vue';
export default {
  name: 'handleComplain',
  mixins: [inputSearch, expireTime],
  data () {
    return {
      imgUrl: false,
      imgVisible: false,
      emptyImage: '',
      modalTitle: '',
      complainant: {},
      complainDetail: {},
      formType: '',
      modalType: undefined,
      reasonList: [],
      detailData: {},
      routeQuery: '',
      visible: false,
      btnLoading: { loading: false },
      toolBarList: [],
      objectInfo: [
        {key: 'type_desc', label: '投诉来源', value: '', span: 8},
        {key: 'chat_category_desc', label: '投诉原因', value: '', span: 8},
        {key: 'create_time', label: '投诉时间', value: '', span: 8},
        {key: 'object_desc', label: '投诉对象', value: '', span: 24}
      ],
      userList: [// 用户投诉：1.投诉不成立  2.封禁投诉对象
        {
          text: '封禁投诉对象',
          handle: (item) => this.toBan(item),
          type: 'primary',
          key: 'userBan',
          vlaue: 2
        },
        {
          text: '投诉不成立',
          handle: (item) => this.handleComplain(item),
          type: 'primary',
          key: 'userRebut',
          value: 1
        }
      ],
      groupList: [// 群聊投诉：1.投诉不成立  2.解散群聊  3.禁止群聊
        {
          text: '解散群聊',
          handle: (item) => this.dismiss(item),
          type: 'danger',
          loading: true,
          key: 'groupDismiss',
          value: 2
        },
        {
          text: '禁言群聊',
          handle: (item) => this.handleComplain(item),
          type: 'primary',
          key: 'groupBan',
          value: 3
        },
        {
          text: '投诉不成立',
          handle: (item) => this.handleComplain(item),
          type: 'primary',
          key: 'groupRebut',
          value: 1
        }
      ],
      dynamicList: [// 动态投诉：1.投诉不成立  2.删除动态  3.封禁发布人
        {
          text: '删除动态',
          handle: (item) => this.deleteHandle(item, '动态'),
          type: 'danger',
          loading: true,
          key: 'dynaDelete',
          value: 2
        },
        {
          text: '封禁发布人',
          handle: (item) => this.toBan(item),
          type: 'primary',
          key: 'dynaBan',
          value: 3
        },
        {
          text: '投诉不成立',
          handle: (item) => this.handleComplain(item),
          type: 'primary',
          key: 'dynaRebut',
          value: 1
        }
      ],
      commentList: [
        {
          text: '删除评论/回复',
          handle: (item) => this.deleteHandle(item, '评论'),
          type: 'danger',
          loading: true,
          key: 'commentDel',
          value: 2
        },
        {
          text: '封禁评论人',
          handle: (item) => this.toBan(item),
          type: 'primary',
          key: 'commentBan',
          value: 3
        },
        {
          text: '投诉不成立',
          handle: (item) => this.handleComplain(item),
          type: 'primary',
          key: 'commentRebut',
          value: 1
        }
      ]
    };
  },
  beforeCreate () {
    this.emptyImage = Empty.PRESENTED_IMAGE_SIMPLE;
    this.form = this.$form.createForm(this);
    this.modalForm = this.$form.createForm(this);
  },
  created () {
    // 1: 用户投诉: ，2: 群聊投诉，3: 动态投诉，4：评论或回复
    this.routeQuery = this.$route.query;
    this.getDetail();
  },
  methods: {
    /** 修改toobar列表 */
    changeBarList (groupType) {
      let typeObj = {
        1: 'userList',
        2: 'groupList',
        3: 'dynamicList',
        4: 'commentList'
      };
      this.toolBarList = this[typeObj[this.routeQuery.type]];
      if (this.routeQuery.type === '2' && groupType === 1) { // grout_type => 1：系统，2：自建
        this.toolBarList[0].disabled = true;
      }
    },
    /* 获取详情 */
    getDetail () {
      this._get({
        url: `/chat/complaint/${this.routeQuery.id}`,
        params: {}
      }).then(({data}) => {
        this.changeBarList(data.group_type);
        this.complainant = { // 投诉人信息
          name: data.nick_name,
          avatar: data.avatar
        };

        for (let item in data) { // 投诉信息
          this.objectInfo.forEach((el) => {
            if (el.key === item) {
              el.value = data[item];

              if (item === 'object_desc') {
                if (['1', '2'].includes(this.routeQuery.type)) {
                  el.value = {
                    avatar: data.object_avatar,
                    name: data.object_desc
                  };
                } else {
                  el.value = {
                    content: data.object_desc,
                    object_nickname: data.object_nickname,
                    object_time: data.object_time
                  };
                }
              }
            }
          });
        }

        this.complainDetail = { // 投诉描述和证明
          content: data.content,
          images: data.images
        };

        let complaintType = {
          1: '1',
          3: '2',
          4: '3'
        };
        this.detailData = { // 提交时使用的参数
          mobile: data.object_mobile,
          complaintId: data.chat_complaint_id,
          userId: data.object_user_id,
          complaintType: complaintType[this.routeQuery.type]
        };
      }).catch(() => {
        this.changeBarList();
      });
    },
    /** 解散群聊 */
    dismiss (item) {
      this.formType = item.value;
      this.$confirm({
        title: '确定要解散此群聊？',
        centered: true,
        onOk: () => {
          this.handleSubmit();
        }
      });
    },
    /** 删除动态、评论或回复 */
    deleteHandle (item, title) {
      this.formType = item.value;
      this.$confirm({
        title: `确定要删除此${title}？`,
        centered: true,
        onOk: () => {
          this.handleSubmit();
        }
      });
    },
    /** 进入封禁对象 */
    toBan () {
      this.$router.push({
        name: 'addBan',
        query: { ...this.detailData, title: '新增封禁' }
      });
    },
    /** 处理投诉 */
    handleComplain (item) {
      this.formType = item.value;
      if (item.text === '投诉不成立') {
        this.modalTitle = '投诉不成立';
        this.modalType = 1;
      } else {
        this.modalTitle = '禁言群聊';
        this.modalType = 2;
        this.getSelect();
      }
      this.visible = true;
    },
    /** 获取下拉
     * 类型：1.禁言； 2.禁止发布动态； 3.禁止发表评论。
     */
    getSelect () {
      this._get({
        url: '/chat/forbidden/selectlist',
        params: { type: 1 }
      }).then(({data}) => {
        this.reasonList = data.category;
      });
    },
    /* 处理表单 */
    handleSubmit  () {
      if (this.visible) {
        this.modalForm.validateFields((err, values) => {
          if (err) { return false; }
          this.handleRequest(values);
        });
      } else {
        this.handleRequest();
      }
    },
    /** 提交表单 */
    handleRequest (values = {}) {
      this._post({
        url: '/chat/complaint',
        params: {
          chat_complaint_id: this.detailData.complaintId,
          handle_type: this.formType,
          ...values
        },
        btnLoading: this.btnLoading
      }).then((res) => {
        this.$message.success(`${res.msg}`);
        this.$router.go(-1);
      });
    }
  }
};
</script>
